import React from "react";
import {
  Input as UIKInput,
  InputProps as UIKInputProps,
} from "@ui-kitten/components";
import { Text } from "react-native";

interface InputProps extends UIKInputProps {
  ref?: any;
}

const Input: React.FC<InputProps> = React.forwardRef(
  ({ children, style, label, ...rest }, ref) => (
    <UIKInput
      style={[
        {
          backgroundColor: "white",
          borderWidth: 2,
          borderRadius: 10,
        },
        [style],
      ]}
      ref={ref}
      {...rest}
      label={(evaProps) => (
        <Text
          {...evaProps}
          style={[
            evaProps?.style,
            {
              color: "black",
              fontWeight: "500",
            },
          ]}
        >
          {label as string}
        </Text>
      )}
    >
      {children}
    </UIKInput>
  )
);

export default Input;
